import React from "react";
import { object, number, string, array, bool } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";

import { getHeadline } from "../../utils/utils";

import "./customStoryCard5.m.css";

const CustomStoryCard5 = ({
  story,
  headlineType = 12,
  className = "custom-story-card-5",
  aspectRatio = [16, 9],
  imageType = "image16x9",
  updateFont = false,
  src,
  publisherLang,
}) => {
  const storyHeadline = getHeadline(story);
  const storyHeadlineStyle = updateFont && src && publisherLang ? `${publisherLang}-headline-style-${src}` : "";
  return (
    <div styleName="base" className={className}>
      <Link href={story.url} className="image-wrapper">
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={[300]}
          showAlternateImage={true}
        />
      </Link>
      <Link href={story.url}>
        <Headline text={storyHeadline} headerLevel={2} headlineType={headlineType} styleName={storyHeadlineStyle} />
      </Link>
    </div>
  );
};

CustomStoryCard5.propTypes = {
  story: object.isRequired,
  headlineType: number,
  className: string,
  aspectRatio: array,
  imageType: string,
  updateFont: bool,
  src: string,
  publisherLang: string,
};

export default CustomStoryCard5;
